/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

/**
 * 配置与推送业务组件的公用 mixin
 */

require('./common.scss')

const store = require('appVuex/store');
const { getTopicList: topicList } = require('appVuex/getter/common')
const { getCityList: cityList } = require('appVuex/getter/common')
const { getCityListValue: cityListValue } = require('appVuex/getter/common')
const { getBrandList: brandList } = require('appVuex/getter/common')
const { tab: tabEvent } = require('components/config/event.json')
const { time } = require('src/common/utils/date')

module.exports = {
  store,

  computed: {
    dateConfig() {
      return {
        format: 'yyyy-mm-dd',
        minView: 'month'
      }
    }
  },

  vuex: {
    getters: {
      topicList,
      cityList,
      cityListValue,
      brandList
    }
  },

  filters: {
    redirectType(val) {
      switch (val) {
        case 0: return '无跳转，直接打开 APP';
        case 1: return '资讯/活动详情页';
        case 2: return '外部链接';
        case 3: return '话题主页';
        default: return '--'
      }
    },

    redirectLink(val, type) {
      if (type === 2 || type === 3) {
        return `${val ? '：' : ''}${val}`
      } else {
        return ''
      }
    },

    status(val) {
      switch (val) {
        case 0: return '生效中';
        case 1: return '已过期';
        case 2: return '未到期';
        case 3: return '已下架';
        default: return '--'
      }
    },

    pushStatus(val) {
      switch (val) {
        case 0: return '未到期';
        case 1: return '已过期';
        case 2: return '已下架';
        case 3: return '生效中';
        case 4: return '推送失败';
        default: return '--'
      }
    },

    platform(val) {
      switch (val) {
        case 1: return 'iOS';
        case 2: return 'Android';
        case 3: return '全部';
        default: return '--'
      }
    },

    pushRange(val, uid) {
      switch (val) {
        case 0: return '全推';
        case 1: return '指定uid';
        case 2: return `尾号：${uid}`;
        default: return '--'
      }
    }
  },

  events: {
    [tabEvent.change](opt) {
      if (!this.$refs || !this.$refs.tableData) {
        return false
      }

      let tableComp = this.$refs.tableData

      switch (opt.item.value) {
        case 0:
          tableComp.query({
            startTime: this.recentDate(7),
            endTime: time(new Date(), 'yyyy-MM-dd hh:mm')
          }).fetch()
          break;
        case 1:
          tableComp.query({
            startTime: this.recentDate(30),
            endTime: time(new Date(), 'yyyy-MM-dd hh:mm')
          }).fetch()
          break;
        case 2:
          tableComp.query({
            startTime: '',
            endTime: ''
          }).fetch()
          break;
        default:
          break;
      }
    }
  },

  methods: {
    recentDate(day) {
      return time(new Date().getTime() - day * 24 * 60 * 60 * 1000, 'yyyy-MM-dd hh:mm')
    },

    switchCity(cityId) {
      if (!this.cityList || this.cityList.length == 0) {
        return ''
      }

      if (cityId.length === 1 && cityId[0] == 999999) {
        return '全国'
      }

      var citys = [];

      cityId.forEach((item) => {
        this.cityList.every((cityItem) => {
          if (cityItem.id === item) {
            citys.push(cityItem.cname)

            return false
          }

          return true
        })
      })

      let cityHub = citys.join('，')
      if (cityHub.length > 20) {
        cityHub = cityHub.slice(0, 20) + '...'
      }

      return cityHub
    },

    offlineDisplay(status) {
      return status === 2
    },

    pushOfflineDisplay(status) {
      return status === 0 || status === 4
    },

    editDisplay(status) {
      return status === 0 || status === 2
    },

    pushEditDisplay(status) {
      return status === 0 || status === 4
    },

    statusColor(status) {
      switch (status) {
        case 0: return 'config-push-green'
        case 1: return 'config-push-grey'
        case 3: return 'config-push-grey'
        default: return ''
      }
    },

    pushStatusColor(status) {
      if (status === 3) {
        return 'config-push-green'
      } else if (status === 0) {
        return ''
      } else {
        return 'config-push-grey'
      }
    },

    cityValues(citys) {
      if (!Array.isArray(citys)) {
        return []
      }

      if (citys.length === 1 && citys[0] == 999999) {
        return this.cityListValue
      }

      return citys
    },

    switchBrand(id) {
      if (id.length === this.brandList.length) {
        return '全部汽车品牌'
      }

      if (!this.brandList || this.brandList.length == 0) {
        return ''
      }

      var brands = [];

      id.forEach((item) => {
        this.brandList.every((brandItem) => {
          if (brandItem.brandId == item) {
            brands.push(brandItem.vertifyBrand)

            return false
          }

          return true
        })
      })

      brands = brands.join('，')

      if (brands.length > 20) {
        brands = brands.slice(0, 20) + '...'
      }

      return brands
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/mixin.js